import React from 'react';
import ImprintBlock from "./util/ImprintBlock";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Impressum = ({

}) => {
	return (
		<Row>
			<Col>
				<div className = {'impressum'}>
					<div className = {'mb-2'}>{'Angaben gemäß § 5 TMG'}</div>
					<ImprintBlock
						headline = {'Inhaltlich verantwortlich'}
						text = {
							'Xeller Training' +
							'\nInhaber: Gerd Xeller' +
							'\nDrosselweg 7' +
							'\n88471 Laupheim' +
							'\n' +
							'\nE-Mail: info(at)xeller.info' +
							'\nTelefon: 07392/9381399' +
							'\n' +
							'\nUmsatzsteuer-Identifikationsnummer gemäß $ 27 Umsatzsteuergesetz: DE255331372'}/>
					<ImprintBlock
						headline = {'Technische Umsetzung'}
						text = {
							'Büro für intelligente Technologie-Beratung' +
							'\nIm Gehag 11' +
							'\n88471 Laupheim' +
							'\nDeutschland' +
							'\n' +
							'\nTelefon: 07392/1636695' +
							'\nTelefax: 07392/9126495' +
							'\nE-Mail: mail(at)berndschattenberg.de' +
							'\n' +
							'\nDatenschutzbeauftragte/r beim Anbieter ist:' +
							'\nDr. Bernd Schattenberg'}/>
					<ImprintBlock
						headline = {'Disclaimer'}
						text = {
							<>
								<h5 className = {'mb-2'}>{'Haftung für Inhalte'}</h5>
								<div className = {'mb-3'}>
									{
										'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen ' +
										'Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, ' +
										'übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf ' +
										'eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von ' +
										'Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist ' +
										'jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von ' +
										'entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'
									}
								</div>
								<h5 className = {'mb-2'}>{'Haftung für Links'}</h5>
								<div className = {'mb-3'}>
									{
										'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. ' +
										'Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten ' +
										'Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten ' +
										'wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum ' +
										'Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist ' +
										'jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von ' +
										'Rechtsverletzungen werden wir derartige Links umgehend entfernen.'
									}
								</div>
								<h5 className = {'mb-2'}>{'Urheberrecht'}</h5>
								<div className = {'d-inline mb-3'}>
									{
										'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen ' +
										'Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der ' +
										'Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. ' +
										'Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit ' +
										'die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter ' +
										'beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine ' +
										'Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden ' +
										'von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.' +
										'\n' +
										'\nQuellverweis: '
									}
								</div>
								<a target = "_blank" href="https://www.e-recht24.de/muster-disclaimer.html">eRecht24 Disclaimer</a>
							</>
						}/>
				</div>
			</Col>
		</Row>
	);
};

export default Impressum;
